import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueI18n from 'vue-i18n';
import Highcharts from 'highcharts';
import Datetime from 'vue-datetime';
import VTooltip from 'v-tooltip';
import VueNotifications from 'vue-notifications';

// import fontawesome for vue
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';

import moment from 'moment';

import KeycloakPlugin from './plugins/keycloak';
import BrokerPlugin from './plugins/broker';
import ApiPlugin from './plugins/api';
import feature from './plugins/feature';

import App from './App';
import store from './store';
import router from './router';
import messages from './languages/messages';

import HighChartsRepsonsive from './components/HighChartsResponsive';

import getFontAwesomeIcons from './FontAwesomeIcons';

import toast from './MiniToastr';

const notifications = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

function initLibs() {
  moment.relativeTimeThreshold('s', 60);
  moment.relativeTimeThreshold('ss', 5);
  Highcharts.setOptions({ global: { useUTC: false } });
}

function initPlugins(kauth) {
  const broker = new BrokerPlugin(kauth);

  const api = new ApiPlugin('api',
    process.env.VUE_APP_API_BASE_URL, async (opt) => {
      const token = await kauth.getValidToken();
      const authHeaders = { Authorization: `Bearer ${token}` };
      opt.headers = { ...authHeaders, ...opt.headers };
      return opt;
    });

  const wapi = new ApiPlugin('wapi',
    process.env.VUE_APP_WHEATHER_API_BASE_URL, async (opt) => {
      if (!opt.query) opt.query = {};
      opt.query.appid = process.env.VUE_APP_WHEATHER_API_KEY;
      return opt;
    });

  Vue.use(kauth);
  Vue.use(broker);
  Vue.use(api);
  Vue.use(feature);
  Vue.use(BootstrapVue);
  Vue.use(VueI18n);
  Vue.use(Datetime);
  Vue.use(VTooltip);
  Vue.use(VueNotifications, notifications);
  store.$api = api;
  store.$wapi = wapi;
  store.$broker = broker;
}

function initGlobalComponents() {
  library.add(getFontAwesomeIcons());
  Vue.component('font-awesome-icon', FontAwesomeIcon);
  Vue.component('font-awesome-layers', FontAwesomeLayers);
  Vue.component('highcharts', HighChartsRepsonsive);
}

function initStoreData() {
  const gcuOpts = {
    query: {
      site: 'all',
      trackers: true
    }
  };
  store.dispatch('savanna/sites/getSites');
  store.dispatch('savanna/gcus/getGCUs', gcuOpts);
  store.dispatch('savanna/trackers/getTrackerStatusCodes');
  store.dispatch('savanna/trackers/getArmatureStatusCodes');
  store.dispatch('savanna/trackers/getTrackers');
}

function init(kauth) {
  Vue.config.performance = true;
  initPlugins(kauth);
  initLibs();
  initGlobalComponents();
  initStoreData();

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    store,
    router,
    i18n: new VueI18n({
      locale: 'en', // set locale
      fallbackLocale: 'en',
      messages // set locale messages
    }),
    template: '<App/>',
    components: {
      App
    }
  });
}

(async function main() {

  const kauth = new KeycloakPlugin({
    realm: 'meerkat',
    url: 'https://accounts.morgansolar.com/auth',
    clientId: 'smc2'
  });

  try {
    const loggedin = await kauth.init({
      onLoad: 'login-required',
      checkLoginIframe: false,
      promiseType: 'native'
    });

    if (loggedin) init(kauth);
  } catch (err) {
    if (err instanceof TypeError) {
      if (err.message.includes('kc.login')) {
        // Ignore Keycloak bug
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
}());
